let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Uf0K")).then(() => parcelRequire('ifsVi'));